import { useQuery } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { commsKeys } from '../queryKeys.js';

export function useProjectMembers(siteId: string | null) {
  const { fetchMembers } = useClientApis().comms;
  return useQuery({
    queryKey: commsKeys.members(siteId ?? ''),
    queryFn: ({ signal }) => fetchMembers(siteId!, signal),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}